import React from 'react';
import { LogOut, Package, Users, Settings, FileText } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const SimplifiedNav: React.FC = () => {
  const { user, userProfile, signOut } = useAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
      window.location.href = '/';
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white shadow-md z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div>
            <a href="/" className="text-xl font-bold text-gray-900">
              Chimperator Live
            </a>
            <p className="text-xs text-gray-500">Webentwicklung Kalkulator</p>
          </div>

          {/* Navigation Links */}
          {user && userProfile && (
            <div className="flex items-center gap-6">
              {/* Customer Navigation - Minimalistic */}
              {userProfile.role === 'customer' && (
                <a
                  href="/my-orders"
                  className={`flex items-center gap-2 text-sm font-medium transition-colors ${
                    window.location.pathname.startsWith('/my-orders')
                      ? 'text-blue-600'
                      : 'text-gray-700 hover:text-gray-900'
                  }`}
                >
                  <Package className="w-4 h-4" />
                  Meine Bestellungen
                </a>
              )}
              
              {/* Team Member Navigation - Tasks */}
              {userProfile.isTeamMember && userProfile.role !== 'admin' && (
                <a
                  href="/my-tasks"
                  className={`flex items-center gap-2 text-sm font-medium transition-colors ${
                    window.location.pathname === '/my-tasks'
                      ? 'text-purple-600'
                      : 'text-gray-700 hover:text-gray-900'
                  }`}
                >
                  <FileText className="w-4 h-4" />
                  Meine Aufgaben
                </a>
              )}

              {/* Admin Navigation */}
              {userProfile.role === 'admin' && (
                <>
                  <a
                    href="/quotes"
                    className={`flex items-center gap-2 text-sm font-medium transition-colors ${
                      window.location.pathname === '/quotes'
                        ? 'text-blue-600'
                        : 'text-gray-700 hover:text-gray-900'
                    }`}
                  >
                    <Users className="w-4 h-4" />
                    {userProfile?.role === 'admin' ? 'Admin Dashboard' : 'Mein Dashboard'}
                  </a>
                  <a
                    href="/"
                    className={`flex items-center gap-2 text-sm font-medium transition-colors ${
                      window.location.pathname === '/'
                        ? 'text-blue-600'
                        : 'text-gray-700 hover:text-gray-900'
                    }`}
                  >
                    Kalkulator
                  </a>
                  <a
                    href="/update-users"
                    className={`flex items-center gap-2 text-sm font-medium transition-colors ${
                      window.location.pathname === '/update-users'
                        ? 'text-blue-600'
                        : 'text-gray-700 hover:text-gray-900'
                    }`}
                  >
                    <Settings className="w-4 h-4" />
                    Einstellungen
                  </a>
                </>
              )}

              {/* User Info & Logout */}
              <div className="flex items-center gap-3 pl-4 border-l border-gray-200">
                <span className="text-sm text-gray-600">
                  {userProfile.displayName}
                </span>
                <button
                  onClick={handleSignOut}
                  className="flex items-center gap-2 text-sm font-medium text-gray-700 hover:text-red-600 transition-colors"
                  title="Abmelden"
                >
                  <LogOut className="w-4 h-4" />
                  Abmelden
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default SimplifiedNav;

